var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12C0.5 5.37258 5.87258 0 12.5 0C19.1274 0 24.5 5.37258 24.5 12C24.5 18.6274 19.1274 24 12.5 24C5.87258 24 0.5 18.6274 0.5 12Z",
    fill: "#E2E9F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3657 4.83211C12.4554 4.80595 12.5507 4.80596 12.6403 4.83215L18.515 6.54828C18.7239 6.60929 18.8675 6.80081 18.8675 7.01842V10.5378C18.8675 14.4477 16.3653 17.9189 12.6558 19.1549C12.5553 19.1884 12.4467 19.1884 12.3462 19.1549C8.6358 17.919 6.13281 14.447 6.13281 10.5362V7.01842C6.13281 6.80076 6.27645 6.60922 6.48539 6.54824L12.3657 4.83211ZM7.1124 7.38571V10.5362C7.1124 13.9706 9.27605 17.0257 12.501 18.1722C15.725 17.0257 17.8879 13.9714 17.8879 10.5378V7.38561L12.5029 5.81254L7.1124 7.38571Z",
    fill: "#35435D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasico);
export default __webpack_public_path__ + "static/media/basico.28b3eb1ca0fb9d08c5748d7bd0b960bc.svg";
export { ForwardRef as ReactComponent };